<template>
  <div id="content">

    <nav class="navbar navbar-expand-md fixed-top pt-0" v-show="!buyTicketsButtonVisible">
      <div class="container pl-0 pr-0" v-show="!buyTicketsButtonVisible">
        <div class="row mx-0" style="background-color: #fff; width: 100%;">
          <div class="col-md-6">
            <h4>
              {{ event.title }}
            </h4>
          </div>

          <div class="col-md-6 pt-2">
            <h4>
              <b-button id="" v-b-modal.customTicketSelectionModal
                class="btn btn-primary col-md-4 col-sm-6 mr-3">
                Buy Tickets
              </b-button>
              <small>
                {{ ticketPrices() }}
              </small>
            </h4>
          </div>
        </div>
      </div>
    </nav>

    <div class="container" style="padding: 0px;">
      <div class="row no-gutters has-map fixed event-show-image-description" style="transform: none;">
        <div class="col-md-6"
          style="position: relative; overflow: visible; box-sizing: border-box; min-height: 1px;">
          <div class="item-gallery item-gallery-custom">
            <div v-if="!event.needLoading && !event.event_available" class="item-badges-show">
              <div class="item-badge-left">Not available</div>
            </div>

            <div v-if="event.image_url">
              <img :src="event.image_url" class="img-fluid">
            </div>
            <div v-else class="text-center">
              <i class="fa fa-picture-o without-image" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div class="col-md-6"
          style="position: relative; overflow: visible; box-sizing: border-box; min-height: 1px;">
          <div class="card card-custom">
            <h4 class="mt-0 mb-1">
              <PuSkeleton> {{ event.title }} </PuSkeleton>
            </h4>
            <h5 class="mt-0 mb-0">
              <template v-if="!event.needLoading"> <div v-html="getEventDate(event)"></div> </template>
              <PuSkeleton v-else />
            </h5>

            <div class="media mt-0">
              <div class="media-body">
                <template v-if="!event.needLoading"> <div v-html="eventShowTime()"></div> </template>
                <PuSkeleton v-else />
                <br/>

                <div><strong>{{ event.venue_name }}</strong></div>
                <div> {{ getEventStreetAddress(event) }} </div>
                <div>
                  {{ getEventLocation(event) }}
                </div>
                <div v-if="showRemainingTickets(event) && !event.sold_out" class="item-location item-location-custom mt-1">
                  <mark><strong> {{ remainingTickets(event.remaining_tickets) }} </strong></mark>
                </div>
              </div>
            </div>

            <b-row class="mt-auto">
              <b-col cols="12" lg="12" md="12" sm="12" xs="12">
                <b-button v-if="event.needLoading" class="btn btn-inverse disabled">
                  Loading...
                </b-button>
                <b-button v-else-if="event.sold_out" class="btn btn-inverse disabled">
                  SOLD OUT
                </b-button>
                <b-button v-else-if="!event.event_available" class="btn btn-inverse disabled">
                  Not available
                </b-button>
                <div v-else class="fixed-bottom-custom" id="buy-event-button">
                  <b-button v-b-modal.customTicketSelectionModal
                    v-observe-visibility="visibilityChanged"
                    class="btn btn-primary">
                    Buy Tickets
                  </b-button>

                  <font v-show="!$isMobile()" class="ml-3 h6">
                    <strong>{{ ticketPrices() }}</strong>
                  </font>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>

    <br/>

    <div class="container" :style="'color: ' + siteConfiguration.event_details_color || '#000'">
      <div class="row no-gutters has-map fixed" style="transform: none;">
        <div class="col-md-6 col-lg-5 col-xl-6"
          style="position: relative; overflow: visible; box-sizing: border-box; min-height: 1px;">

          <div class="item-description">
            <h4 :style="'color: ' + siteConfiguration.event_details_color || '#000'">
              <strong>Description</strong>
            </h4>
            <template v-if="!event.needLoading"> <p v-html="markedText(event.description)"></p> </template>
            <PuSkeleton v-else width="85%" height="30px"/>

            <h4 :style="'color: ' + siteConfiguration.event_details_color || '#000'">
              <strong>Organizer Details</strong>
            </h4>

            <template v-if="!event.needLoading">
              <strong> {{ event.organizer_name }} </strong> <br/>
              <p>
                {{ event.organizer_description }}
              </p>
            </template>
            <PuSkeleton v-else width="85%" height="30px"/>

            <template v-if="event.organizer_website">
              <a :href="event.organizer_website" target="_blank"
                :style="'color: ' + siteConfiguration.body_link_color || '#00f'">
                {{ event.organizer_website }}
              </a>
              <br/>
            </template>

            <template v-if="event.organizer_contact_phone_number">
              <a :href="`tel:+1${extracNumbers(event.organizer_contact_phone_number)}`"
                rel="nofollow" :style="'color: ' + siteConfiguration.body_link_color || '#00f'">
                {{ event.organizer_contact_phone_number }}
              </a>
              <br/>
            </template>

            <template v-if="event.organizer_facebook_id">
              <a :href="socialMediaLinks(event.organizer_facebook_id, 'facebook')"
                target="_blank" :style="'color: ' + siteConfiguration.body_link_color || '#00f'">
                <i class="fa fa-facebook-official" aria-hidden="true"></i>
                {{ event.organizer_facebook_id }}
              </a>
              <br/>
            </template>

            <template v-if="event.organizer_twitter_id">
              <a :href="socialMediaLinks(event.organizer_twitter_id, 'twitter')"
                target="_blank" :style="'color: ' + siteConfiguration.body_link_color || '#00f'">
                <i class="fa fa-twitter" aria-hidden="true"></i>
                {{ event.organizer_twitter_id }}
              </a>
              <br/>
            </template>

            <template v-if="event.organizer_instagram_id">
              <a :href="socialMediaLinks(event.organizer_instagram_id, 'instagram')"
                target="_blank" :style="'color: ' + siteConfiguration.body_link_color || '#00f'">
                <i class="fa fa-instagram" aria-hidden="true"></i>
                {{ event.organizer_instagram_id }}
              </a>
              <br/>
            </template>
            <br />
            <br />

            <b-button v-b-modal.formContactModal class="btn btn-primary col-lg-8 mt-10">
              Contact Us
            </b-button>

            <ContactEventForm
              :event="event">
            </ContactEventForm>
          </div>
        </div>

        <div class="col-md-6 col-lg-5 col-xl-6"
          style="position: relative; overflow: visible; box-sizing: border-box; min-height: 1px;">
          <div class="item-description">
            <h4 :style="'color: ' + siteConfiguration.event_details_color || '#000'">
              <strong>Refund Policy</strong>
            </h4>

            <template v-if="!event.needLoading"> <p> {{ event.policy_refund }} </p> </template>
            <PuSkeleton v-else width="85%" height="30px"/>
          </div>
        </div>
      </div>
    </div>

    <CustomTicketsSelectionModal
      :tickets="event.tickets_attributes || []"
      :event="event"
      :applicationSettings="applicationSettings"
      :showRemainingTickets="event.show_remaining_tickets"
      @show-ticket="showTicket"
    />
    <script v-html="eventStructuredData" type="application/ld+json" />
  </div>
</template>

<script>
import ContactEventForm from '../../common/ContactForm'
import CustomTicketsSelectionModal from './CustomTicketsSelectionModal'
import StructuredData from '../../common/StructuredData'
import GA from '../../common/GA'
import { ObserveVisibility } from 'vue-observe-visibility'
import EventPublicService from '../../../services/EventPublicService'
import ApplicationSettingService from '../../../services/ApplicationSettingService'

export default {
  name: 'EventShow',
  mixins: [StructuredData, GA],
  components: {
    ContactEventForm,
    CustomTicketsSelectionModal
  },
  props: {
    siteConfiguration: {
      type: Object,
      required: true
    }
  },
  directives: {
    ObserveVisibility
  },
  data () {
    return {
      buyTicketsButtonVisible: true,
      event: {
        event_dates_attributes: [{}],
        needLoading: true
      },
      showTicketSelectionModal: this.$route.params.showTicketSelectionModal,
      applicationSettings: {
        TICKET_FEE: {
          value: 0
        }
      },
      eventStructuredData: {},
      eventId: this.$route.params.id,
      pagePath: this.$router.currentRoute.fullPath
    }
  },
  created () {
    this.loadEvent()
    this.loadEventStructuredData(this.eventId)
    this.loadGAIdByEventId(this.eventId)
    this.getApplicationSettings()
    window.scrollTo(0, 0)
  },
  mounted () {
    if (this.showTicketSelectionModal) {
      this.$bvModal.show('customTicketSelectionModal')
    }
  },
  head () {
    if (!this.event.needLoading) {
      let eventTitle = this.event.title
      let eventDescription = this.event.description
      let url = window.location.href
      let socialImageUrl = this.profileSocialImageUrl(this.$parent.siteConfiguration)
      let twitterAccount = this.profileTwitterAccount(this.$parent.siteConfiguration)

      return {
        meta: this.dynamicMetaTags(eventTitle, eventDescription, url, socialImageUrl, twitterAccount),
        script: this.gaTagBuilder()
      }
    } else {
      return []
    }
  },
  methods: {
    showTicket (ticket) {
      return (this.$root.logged === true && this.$localStorage.get('user_type').match(/admin|client_admin|staffer/) && ticket.wait_list === true) || (ticket.wait_list !== true)
    },
    getApplicationSettings () {
      var self = this

      ApplicationSettingService.getApplicationSetting().then((response) => {
        response.data.forEach(function (appSetting, index) {
          self.applicationSettings[appSetting.name] = {
            value: appSetting.value,
            id: appSetting.id
          }
        })
      })
    },
    loadEvent () {
      var self = this
      var loader = this.$loading.show()

      EventPublicService.getEvent(this.eventId).then((response) => {
        self.event = response.data
        self.event.needLoading = false
        self.$emit('updateHead')
      }).finally(function () {
        loader.hide()
      })
    },
    eventShowTime () {
      if (this.event && !this.event.needLoading) {
        let eventShowDateTime = this.event.event_dates_attributes[0].formatted_time_starts_at || ''
        let eventTimeZoneAbbr = this.event.event_dates_attributes[0].time_zone_abbr

        eventShowDateTime = eventShowDateTime.concat(` ${eventTimeZoneAbbr}`)
        return `<strong> ${eventShowDateTime.concat(' Showtime')} </strong>`
      }
    },
    ticketPrices () {
      let ticketList = []

      if (this.event.tickets_attributes) {
        this.event.tickets_attributes.forEach((ticket) => {
          let priceLoaded = ticketList.find(el => el.price === ticket.price_with_fee)

          if (!priceLoaded) {
            ticketList.push({
              formatted_price: ticket.formatted_price_with_fee,
              price: ticket.price_with_fee
            })
          }
        })
      }

      if (ticketList.length > 1) {
        ticketList.sort((a, b) => {
          return a.price - b.price
        })

        return `${ticketList[0].formatted_price} - ${ticketList[ticketList.length - 1].formatted_price}`
      } else {
        return (ticketList[0] || {}).formatted_price
      }
    },
    visibilityChanged (isVisible, entry) {
      this.buyTicketsButtonVisible = isVisible
    }
  }
}
</script>
